import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useHistory, useLocation } from 'react-router-dom';
import { AuthContext, ContentContext } from '../../_context';
import CircularProgress from '@material-ui/core/CircularProgress';
import { breakpoints } from '../../_helpers/breakpoints';
import { incentivoTiendas, inventivo_tiendas_2 } from '../../_helpers/commons';
import { ButtonYellow } from '~/_elements';
import { HiMiniBellAlert } from "react-icons/hi2";
import ReactPlayer from 'react-player';

import axios from 'axios';

dayjs.extend(utc);
dayjs.extend(timezone);
/*
setBackground({default: false,
                       type: 'image',
                       url: '/images/back_promojeep.jpg',
                       //url: '/images/background_challengebox.jpg',
                       repeat: 'repeat',
                       attachment: 'fixed',
                       size: 'cover'});

        //setBackground({default: true, type: 'color', hexa: '#FFC600'});
        setColorPallete({type: 'shellbox', primary: '#FFD200', secondary: '#FFFFFF', terciary: '#F5F6FA', border: '255, 210, 0', background: 'rgba(0, 0, 0, 0.5)', altbackground: 'rgba(0, 0, 0, 0.5)'});
*/

const Wrapper = styled.div`
    width: 100%;
    background-image: url('/images/back_promojeep.jpg');
    background-repeat: repeat;
    background-attachment: fixed;
    background-size: cover;

    padding-left: 20px;
    padding-right: 20px;
    .shake-bell{
        animation: shake 0.5s;
        animation-iteration-count: infinite;
    }   

    @keyframes shake {
        0% { transform: translateX(0) rotate(0deg); }
        20% { transform: translateX(-1px) rotate(-10deg); }
        40% { transform: translateX(1px) rotate(10deg); }
        60% { transform: translateX(-1px) rotate(-8deg); }
        80% { transform: translateX(1px) rotate(8deg); }
        100% { transform: translateX(0) rotate(0deg); }
    }
    .aclaracion_48{
        text-align: center;
        font-weight: 600;
        margin-top: 50px;
        //margin-bottom: 20px;
        padding-left: 20px;
        padding-right: 20px;
    }
    .renegade{
        display: flex;
        justify-content: center;
        width: 100%;
        margin-top: 30px;
        .image{
            width: 100%;
            img{
                float: left;
                width: 100%;
            }
        }
    }
    .description{
        text-align: center;
        width: 100%;
        font-size: 18px;
        line-height: 24px;
        margin: 30px 0;
        font-weight: 600;
    }
    .publish_date{
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 14px;
        line-height: 14px;
        margin-top: 15px;
        font-weight: 600;
        border: 1px dashed #E30613;
        padding: 7px 10px 5px 10px;
        border-radius: 6px;
        background-color: #FFFFFF;
        box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
        -webkit-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
        -moz-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
        .icon{
            display: flex;
            font-size: 21px;
            line-height: 21px;
            margin-right: 5px;
            color: #E30613;
        }
        p{
            padding: 0;
            margin: 0;
            color: #E30613;
            line-height: 17px;
        }
    }
    .box_objectives_extras{
        display: flex;
        flex-direction: column;
        margin-top: 15px;
        width: 100%;
        .box_objective_extras{

            display: flex;
            flex-direction: column;
            //margin-top: 30px;
            margin-right: 10px;
            margin-bottom: 15px;
            width: 100%;
            
            border-radius: 6px;
            border: 1px solid #FFC600;
            border-bottom: 5px solid #FFC600;
            box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
            -webkit-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
            -moz-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
            .tabs{
                display: flex;
                flex-direction: row;
                .tab{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 50%;
                    border: 1px solid #E30613;
                    background-color: #FFC600;
                    text-align: center;
                    font-size: 14px;
                    line-height: 14px;
                    font-weight: 600;
                    height: 30px;
                    border-bottom-color: #FFC600;
                    cursor: pointer;
                    &.active{
                        color: #FFFFFF;
                        background-color: #E30613;
                    }
                    &.alone{
                        cursor: default;
                        width: 100%;
                        color: #FFFFFF;
                        background-color: #E30613!important;
                    }
                    :first-child{
                        border-top-left-radius: 6px;
                        border-right: 1px solid #FFC600;
                    }
                    :last-child{
                        border-top-right-radius: 6px;
                    }
                    :hover{
                        background-color: #E30613;
                        color: #FFFFFF;
                    }
                }
            }
            .title{
                background-color: #E30613;
                //
                //
                padding: 20px 30px;
                text-align: center;
                .label{
                    color: #FFFFFF;
                    font-size: 17px;
                    font-weight: 600;
                }
            }

            ul, li{
                margin: 0;
                padding: 0;
                list-style: none;
            }
            ul{
                display: flex;
                flex-direction: column;
                width: 100%;
                li{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 100%;
                    /* background-color: aliceblue; */
                    background-color: rgba(255,255,255,0.95);
                    padding: 20px 30px;
                    margin-right: 0;
                    //margin-top: 20px;
                    //border-radius: 6px;
                    //border: 1px solid #FFC600;
                    border-bottom: 1px solid #FFC600;

                    /* border-radius: 6px;
                    border: 1px solid #FFC600;
                    border-bottom: 5px solid #FFC600;
                    box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
                    -webkit-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
                    -moz-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19); */
                    margin: 0!important;
                    /* &.title{
                        background-color: #E30613;
                        .label{
                            color: #FFFFFF;
                            font-size: 17px;
                        }
                    } */
                    :last-child{
                        //margin-right: 0;
                        //border-bottom-left-radius: 6px;
                        border-bottom-right-radius: 6px;

                    }
                    :first-child{
                        border-bottom-left-radius: 6px;
                        //border-top-right-radius: 6px;

                    }
                    .label{
                        text-transform: uppercase;
                        font-size: 12px;
                        line-height: 12px;
                        font-weight: 600;
                    }
                    .value{
                        font-size: 40px;
                        line-height: 40px;
                        font-weight: 800;
                        margin-top: 7px;
                        color: #FFC600;
                    }
                }
            }
            &:first-child{
                margin-right: 0;
                margin-bottom: 15px;
            }
            &:last-child{
                margin-right: 0;
                margin-bottom: 0;
            }   
            
        }
       
    }








    
    .logos{
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
        display: flex;
        flex-direction: row;

        .logo_jeep_shell{
            margin-top: 3.3vw;
            width: 90px;
        }
        .logo_shell_tag{
            width: 400px;
            margin-left: 5vw;
            margin-right: 5vw;
        }
        .logo_jeep_shellbox{
            margin-top: 3vw;
            width: 83px;
        }

        

        /*
        .select,
        .box,
        .shop{
            width: 28vw;
            height: 24vw;
            padding-bottom: 3vw;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            background-color: #FFC600;
            border-bottom-left-radius: 5vw;
            border-bottom-right-radius: 5vw;
            margin-right: 3vw;
        }
        .select{
            .logo{
                width: 20vw;
                padding-bottom: 1.8vw;
                img{
                    float: left;
                    width: 100%;
                }
            }
        }
        .box{
            .logo{
                width: 20vw;
                img{
                    float: left;
                    width: 100%;
                }
            }
        }
        .shop{
            margin-right: 0;
            .logo{
                width: 20vw;
                padding-bottom: 2vw;
                img{
                    float: left;
                    width: 100%;
                }
            }
        }
        */
    }
    .loading{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 30px;
        svg{
            color: #FFC600;
        }
    }
    >.inner{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 0;
        .objectives_container{
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 100%;
            .objective_container{
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                :last-child{
                    margin-left: 0;
                    margin-right: 0;
                }
            }
        }
        .actions{
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            grid-gap: 10px;
            width: 100%;
            margin-top: 30px;
            //display: flex;
            //flex-direction: row;
            //margin-top: 30px;
            .bt_download_reglamento,
            .bt_download_mecanica,
            .bt_download_tips_shell_box,
            .bt_download_tips_shell_vpower{
                width: 100%;
                border: 2px solid #E30613;
                background-color: #E30613;
                color: #FFFFFF;
                :hover{
                    border: 2px solid #E30613;
                    background-color: #FFFFFF;
                    p{
                        color: #E30613;
                    }
                }
            }
            .bt_download_reglamento{
                &:disabled{
                    opacity: 0.4;
                }
            }
            
            .bt_download_tips_shell_vpower{
                //margin-left: 10px;
            }
            .bt_download_mecanica{
                //margin-left: 10px;
                //margin-right: 10px;
            }
        }
        .bt_cursos_pendientes{
            margin-top: 40px;
            margin-bottom: 10px;
            background-color: #FFFFFF;
            border: 2px solid #E30613;
            color: #E30613;
            :hover{
                background-color: #E30613;
                border: 2px solid #FFFFFF;
                p{
                    color: #FFFFFF;
                }
            }
        }
        >.title{
            text-align: center;
            text-transform: uppercase;
            font-weight: 800;
            width: 100%;
            font-size: 40px;
            line-height: 45px;
            margin-bottom: 25px;
            margin-top: 35px;
            /* border-bottom: 1px solid #e9e8e8; */
            .brand{
                white-space: nowrap;
                color: #FFFFFF;//FFC600
            }
        }
        .data_station{
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            width: 100%;
            .station{
                display: flex;
                flex-direction: column;
                align-items: center;
                .label{
                    font-size: 12px;
                    line-height: 12px;
                    font-weight: 400;
                    text-transform: uppercase;
                }
                .value{
                    font-size: 40px;
                    line-height: 40px;
                    font-weight: 600;
                    margin-top: 5px;
                }
            }
            .name{
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-top: 30px;
                .label{
                    font-size: 12px;
                    line-height: 12px;
                    font-weight: 400;
                    text-transform: uppercase;
                }
                .value{
                    font-size: 40px;
                    line-height: 40px;
                    font-weight: 600;
                    margin-top: 5px;
                }
            }
            .select_boca{
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-top: 35px;
                width: 100%;
                label{
                    text-transform: uppercase;
                    font-size: 16px;
                    line-height: 16px;
                }
                select{
                    width: 100%;
                    padding: 10px 10px;
                }
            }
        }
        .objective_title{
            font-size: 23px;
            line-height: 23px;
            font-weight: 800;
            text-transform: uppercase;
            margin-top: 30px;
            color: #000000;//FFC600
            //border-bottom: 1px solid #000000;
            text-align: center;
        }
        .copy{
            width: 100%;
            display: flex;
            flex-direction: column;
            text-align: center;
            margin-top: 30px;
            margin-bottom: 0;
            color: #212529;
            p{
                margin: 0;
                padding: 0;
                font-size: 16px;
                line-height: 20px;
            }
            .l1{
            }
            .l2,
            .l3{
                font-weight: 600;
                margin-top: 10px;
            }
            .l3{
                color: #FFC600;
            }
        }
        .box_objectives{
            display: flex;
            flex-direction: column;
            margin-top: 15px;
            width: 100%;
            justify-content: center;
        
        }
        .box_objective{
            display: flex;
            flex-direction: column;
            //margin-top: 30px;
            margin-right: 0;
            //width: 206px;
            
            width: 100%;
            margin-right: 0;
            margin-bottom: 15px;
            

            border-radius: 6px;
            border: 1px solid #FFC600;
            border-bottom: 5px solid #FFC600;
            box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
            -webkit-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
            -moz-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
            
            ul, li{
                margin: 0;
                padding: 0;
                list-style: none;
            }
            ul{
                display: flex;
                flex-direction: column;
                width: 100%;
                li{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    /* background-color: aliceblue; */
                    background-color: rgba(255,255,255,0.95);
                    padding: 20px 30px;
                    margin-right: 0;
                    //margin-top: 20px;
                    //border-radius: 6px;
                    //border: 1px solid #FFC600;
                    border-bottom: 1px solid #FFC600;

                    /* border-radius: 6px;
                    border: 1px solid #FFC600;
                    border-bottom: 5px solid #FFC600;
                    box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
                    -webkit-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
                    -moz-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19); */
                    margin: 0!important;
                    &.title{
                        background-color: #E30613;
                        .label{
                            color: #FFFFFF;
                            font-size: 17px;
                        }
                    }
                    :last-child{
                        margin-right: 0;
                        border-bottom-left-radius: 6px;
                        border-bottom-right-radius: 6px;

                    }
                    :first-child{
                        border-top-left-radius: 6px;
                        border-top-right-radius: 6px;

                    }
                    .label{
                        text-transform: uppercase;
                        font-size: 12px;
                        line-height: 12px;
                        font-weight: 600;
                    }
                    .value{
                        font-size: 40px;
                        line-height: 40px;
                        font-weight: 800;
                        margin-top: 7px;
                        color: #FFC600;
                    }
                }
            }
            &:first-child{
                margin-right: 0;
                margin-bottom: 15px;
            }  
            &:last-child{
                margin-right: 0;
                margin-bottom: 0;
            } 
        }
    }
    @media ${breakpoints.xs} {
        
        .logos{
            display: flex;
            flex-direction: row;
            /*
            .select,
            .box,
            .shop{
                width: 150px;
                height: 130px;
                padding-bottom: 15px;
                border-bottom-left-radius: 25px;
                border-bottom-right-radius: 25px;
                margin-right: 20px;
            }
            .select{
                .logo{
                    width: 100px;
                    padding-bottom: 5px;
                }
            }
            .box{
                .logo{
                    width: 90px;
                    img{
                        float: left;
                        width: 100%;
                    }
                }
            }
            .shop{
                margin-right: 0;
                .logo{
                    width: 100px;
                    padding-bottom: 8px;
                }
            }
            */
        }
        >.inner{
            
            .box_objective{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                //width: 206px;
                //margin-top: 30px;
                //margin-right: 10px;
                ul, li{
                    margin: 0;
                    padding: 0;
                    list-style: none;
                }
                ul{
                    display: flex;
                    flex-direction: column;
                    li{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        /* background-color: aliceblue; */
                        padding: 20px 30px;
                        //margin-right: 20px;
                        margin-top: 0;
                        //border-radius: 6px;
                        //border: 1px solid #FFC600;
                        //border-bottom: 5px solid #FFC600;

                        /* box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
                        -webkit-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19);
                        -moz-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.19); */
                        :last-child{
                            margin-right: 0;
                        }
                        .label{
                            text-transform: uppercase;
                            font-size: 12px;
                            line-height: 12px;
                            font-weight: 600;
                        }
                        .value{
                            font-size: 40px;
                            line-height: 40px;
                            font-weight: 800;
                            margin-top: 7px;
                            color: #FFC600;
                        }
                    }
                }
            }
            .data_station{
                .select_boca{
                    margin-top: 35px;
                    width: 400px;
                    label{
                        text-transform: uppercase;
                        font-size: 16px;
                        line-height: 16px;
                    }
                    select{
                        width: 100%;
                        padding: 10px 10px;
                    }
                }
            }
            .actions{
                display: grid;
                //grid-template-columns: repeat(1, 1fr);
                grid-template-columns: repeat(2, 1fr);
                grid-gap: 10px;
                //width: 225px;
                width: 650px;
            }
        }
    }
    @media ${breakpoints.sm} {
        padding-left: 0;
        padding-right: 0;
        .description{
            width: 600px;
        }
        .box_objectives{
            display: flex;
            flex-direction: row!important;
            
            margin-top: 15px;
            .box_objective{
                display: flex;
                flex-direction: row;
                width: 230px;
                margin-right: 10px!important;
                margin-bottom: 0;
                &:first-child{
                    margin-bottom: 0;
                    
                }
                &:last-child{
                    margin-bottom: 0;
                    margin-right: 0!important;
                }   
            }
        
        }
        .box_objectives_extras{
            display: flex;
            flex-direction: row;
            margin-top: 15px;
            width: 570px;
            .box_objective_extras{
                &:first-child{
                    margin-right: 10px;
                    margin-bottom: 0;
                }
                &:last-child{
                    margin-right: 0;
                    margin-bottom: 0;
                }
            }
        }
        .logos{
            display: flex;
            flex-direction: row;
            width: 793px;
            .logo_jeep_shell{
                margin-top: 23px;
                width: 90px;
            }
            .logo_shell_tag{
                width: 400px;
                margin-left: 90px;
                margin-right: 90px;
            }
            .logo_jeep_shellbox{
                margin-top: 23px;
                width: 83px;
            }
        }
        >.inner{
            /*
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 0;
            */
            
            .actions{
                display: grid;
                //grid-template-columns: repeat(1, 1fr);
                grid-template-columns: repeat(2, 1fr);
                grid-gap: 10px;
                //width: 225px;
                width: 650px;
            }
        }
        .renegade{
            .image{
                width: 600px;
            }
        }
    }
    @media ${breakpoints.md} {
        .description{
            width: 800px;
        }
    }
    @media ${breakpoints.lg} {
        
    }
    @media ${breakpoints.xl} {
        >.inner{
            .objectives_container{
                display: flex;
                flex-direction: row;
                justify-content: center;
                .objective_container{
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: center;
                    :last-child{
                        margin-left: 10px;
                    }
                }
            }
        }
    }
    

    
    




    .video_modal_overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        padding: 20px;
    }

    .video_modal_content {
        position: relative;
        width: 90%;
        max-width: 1200px;
        aspect-ratio: 16 / 9; /* Mantiene la proporción 16:9 del video */
        background-color: #000;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
    }

    .video_modal_header {
        position: absolute;
        top: 15px;
        right: 15px;
        z-index: 10000;
    }

    .close_button {
        background: rgba(255, 255, 255, 0.9);
        border: none;
        border-radius: 50%;
        width: 35px;
        height: 35px;
        font-size: 18px;
        font-weight: bold;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s ease;
        color: #000;
        
        &:hover {
            background: rgba(255, 255, 255, 1);
            transform: scale(1.1);
        }
    }

    .video_modal_player {
        width: 100%;
        height: 100%;
        position: relative;
        
        .react-player-modal {
            position: absolute;
            top: 0;
            left: 0;
        }
    }

    /* Responsive para diferentes tamaños */
    @media ${breakpoints.xs} {
        .video_modal_overlay {
            padding: 10px;
        }
        
        .video_modal_content {
            width: 95%;
            max-width: none;
        }
        
        .video_modal_header {
            top: 10px;
            right: 10px;
        }
        
        .close_button {
            width: 30px;
            height: 30px;
            font-size: 16px;
        }
    }

    @media ${breakpoints.sm} {
        .video_modal_content {
            width: 85%;
            max-width: 800px;
        }
    }

    @media ${breakpoints.md} {
        .video_modal_content {
            width: 80%;
            max-width: 1000px;
        }
    }

    @media ${breakpoints.lg} {
        .video_modal_content {
            width: 75%;
            max-width: 1200px;
        }
    }

    /* Para pantallas muy altas, limitar la altura máxima */
    @media (max-height: 600px) {
        .video_modal_content {
            width: auto;
            height: 80vh;
            aspect-ratio: 16 / 9;
        }
    }






    .cursos_modal_overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        padding: 20px;
    }

    .cursos_modal_content {
        position: relative;
        width: 90%;
        max-width: 600px;
        background-color: #FFFFFF;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
        padding: 0;
    }

    .cursos_modal_header {
        position: absolute;
        top: 15px;
        right: 15px;
        z-index: 10000;
    }

    .cursos_modal_body {
        padding: 50px 30px 30px 30px;
        text-align: center;
        
        h3 {
            color: #E30613;
            font-size: 24px;
            font-weight: 800;
            margin-bottom: 20px;
            text-transform: uppercase;
        }
        
        >p {
            color: #333;
            font-size: 18px;
            line-height: 24px;
            margin-bottom: 30px;
            text-align: left;
        }
    }

    .cursos_modal_actions {
        display: flex;
        justify-content: center;
        width: 100%;
    }

    /* Responsive para el modal de cursos */
    @media ${breakpoints.xs} {
        .cursos_modal_overlay {
            padding: 10px;
        }
        
        .cursos_modal_content {
            width: 95%;
            max-width: none;
        }
        
        .cursos_modal_body {
            padding: 40px 20px 20px 20px;
            
            h3 {
                font-size: 20px;
            }
            
            p {
                font-size: 16px;
                line-height: 22px;
            }
        }
        
        .cursos_modal_header {
            top: 10px;
            right: 10px;
        }
    }

    @media ${breakpoints.sm} {
        .cursos_modal_content {
            width: 85%;
            max-width: 500px;
        }
    }




`
/*

Competencia promo jeep
Shell VPOWER (%)
SHELL BOX PLAYA
SHELL BOX TIENDA

Meta de Negocio
Meta de Desempeño

Cursos Pendientes

*/
const MetaJeep = props => {
    
    let history = useHistory();

    const { isAuth } = useContext(AuthContext);
    const { userData } = useContext(ContentContext);

    const [ metaData, setMetaData ] = useState(null);
    const [ dataStation, setDataStation ] = useState(null);
    const { search, pathname } = useLocation();
    const [ uid, setUid ] = useState(null);
    const [ modificatedDate, setModificatedDate ] = useState(null);
    const [ red, setRed ] = useState('');
    const [ tabActividad, setTabActividad ] = useState('individual');
    const [ tabCursos, setTabCursos ] = useState('individual');
    const [ dataDesempeno, setDataDesempeno ] = useState(null);

    const [ actividadObjetivo, setActividadObjetivo ] = useState(null);
    const [ actividadResultado, setActividadResultado ] = useState(null);
    const [ actividadCalculo, setActividadCalculo ] = useState(null);

    const [ actividadIndividualObjetivo, setActividadIndividualObjetivo ] = useState(null);
    const [ actividadIndividualResultado, setActividadIndividualResultado ] = useState(null);
    const [ actividadIndividualCalculo, setActividadIndividualCalculo ] = useState(null);

    const [ actividadEstacionObjetivo, setActividadEstacionObjetivo ] = useState(null);
    const [ actividadEstacionResultado, setActividadEstacionResultado ] = useState(null);
    const [ actividadEstacionCalculo, setActividadEstacionCalculo ] = useState(null);

    const [ cursosObjetivo, setCursosObjetivo ] = useState(null);
    const [ cursosResultado, setCursosResultado ] = useState(null);
    const [ cursosCalculo, setCursosCalculo ] = useState(null);

    const [ showVideoModal, setShowVideoModal ] = useState(false);
    const [ isPlaying, setIsPlaying ] = useState(false);
    const [ showCursosModal, setShowCursosModal ] = useState(false);

    useEffect(() => {
        
        if(pathname){
            //console.log("pathname", pathname)
            if(pathname == '/promo-jeep'){
                if(!isAuth){
                    if(search.length > 0) {
                        
                        const query = new URLSearchParams(search);
                        //console.log("query", query);
                        if(query.get("uid") && query.get("uid").length > 0){
                            setUid(query.get("uid"));
                        }else{

                        }
                    }else{

                    }
                }
            }
        }
        return () => {}

    }, [pathname, isAuth])

    useEffect(() => {

        if(isAuth && userData){
            setUid(userData.dni);
        }
        return () => {}

    }, [isAuth, userData])

    const empresarios = ["30834417","14750489","11525249","23262657","18007297","21478376","223344","42086119","23873222","500050","22716807","40802601","31445846","28335167","32654471","21646692","27061407","34777282","31152267","33309452","27744049","38383240","37981442","30493679","37934502","23944248","28324463","36676525","38795006","25513516","27687394","38632619","22945965","20537395","24785521","34419730","20585304","23262799","27654964","25269579","33935989","29511091","22249750","17695477","33014886","28351819","36765180","40395133","36401792","14296155","37938934","25105951","11874342","14945087","26237005","26896603","4448478","23157688","31210715","17586090","32920393","37647267","93316218","7791753","16115812","20911525","29043030","21866699","29825508","25425403","18477263","17287834","22802765","7667474","21882874","17557367","24047263","11251613","20585835","30581636","29728455","12487016","28445117","24351767","21720166","21099233","28598229","27254985","28386134","21548522","14889050","20939007","24642401","41472689","26035945","13426328","11281007","39628516","20495469","14565643","21644696","23337849","30707436456","6301487","6075666","14764331","12869417","21466800","25814167","12286977","23092369","10161203","21441667","16586176","17587663","23438226","17508951","16626821","23492155","28395913","14780156","14095123","29381143","16552494","18052399","22503690","14292139","8488065","20686961","13407084","17126994","12681219","31537867","7891618","23162378","23938269","8073008","8119419","14267779","22601908","16475364","26587253","23067249","30625878884","26074224","28839378","26387137","8627014","5834027","29961945","14844426","25410194","22675627","21418503","18074357","33589736","5832752","22119919","25366883","10455144","29399496","24095666","27364977","16829950","23815666","30768870","27234094","14228009","17399025","20704236","32851761","93268791","30090333","28767484","29005147","28419045","30926385","12662689","34131273","26884480","23211681","26858119","14710294","10985525","27862366","26165212","6044320","14894390","22952506","25152109","11287556","93883995","32318249","24425209","18249104","31923709","28513451","22328552","34162763","11979171","31730703","26321254","23968748","29379456","28539333","22924130","23810110","30900778","17342858","10512034","22538792","21930637","12762151","17908122","17338927","14015795","8593064","23572101","24632679","21651672","3254633","16390083","32407488","33045152","33335884","21434609","21569792","4445055","28749027","22123819","24676193","20507951","29710740","30804274","14271843","13470541","21924773","31782184","27833149","13242617","23448472","18181881","93877943","18080872","14877779","26235164","8489287","27863912","22534192","18680171","13784215","13646254","14469636","21961629","22458577","11594698","34564326","14742306","20627984","20681343","8652654","31828135","17327927","30626103","32398323","13133760","16664935","14819241","10939432","13683592","8326365","4097351","21822042","25181114","23418413","17528263","7646448","24615577","18481201","24293232","7961211","11630849","10792294","13255820","14558025","16201346","22073882","25444473","13347203","16899378","30685413","18025231","13145003","10047974","17327941","22722552","24781365","14277366","92198952","11660861","17658661","13086481","30566102","21502709","28526573","6229300","26487738","28776327","18511289","20734737","30712490442","20005970","24797399","28202104","5698208","5345506","21878574","34901641","8415698","5579477","22656263","33733950","23765804","8490127","5695616","17141121","13562985","28506356","35650727","22406902","4578238","26514366","22286810","20608065","12050475","12889050","14082634","5584876","10492383","26815867","17252996","27367274","23191310","7903189","27300095","16069613","23700780","26936487","33267028","4296146","12584427","23374282","16610725","22060809","7356056","20151175","26868726","22416065","16262464","11625974","18118239","31573044","30923538","24167520","5051058","17630600","25985002","22582911","23746136","21471553","5087096","23890473","26466602","4971038","16164481","29321602","21556869","36866184","33374421","31127498","25343374","22287660","17641356","17025866","13353256","20280438","7562694","92109049","12268353","25620443","22209368","13784210","30708138599","29175382","21415670","22446073","7996881","78916185","8498712","36309201","31379779","12455934","10424496","10930091","11775969","12633657","30137746","25651619","26520536","14455964","28910702","36072669","29579897","36886771","26461358","8522535","93667736","27891021","16037507","23757548","25058311","12549383","21672711","21676271","18074767","23770596","24198816","14984392","37014983","20196343","25501823","12941102","8400521","32369585","10374750","6235164","35080379","26906628","31745856","30763391","39910978","13645769","29426397","11600541","76577373","38057670","24560391","21864947","18506546","11033114","13565855","17351644","38426356","5028500","29577521","36194857","29063327","32928161","30614329","18261695","37831094","36617879","20067990","20427520","27154886","22922162","34908882","36356449","26744253","28428371","29246232","95017379","26806314","36786720","12345","36688609","16519474","24906126","38972771","23033040","30486268","26204387","21884035","29157456","23930907","33139094","12792867","17737650","25144089","28442112","93683524","28639038","30101557","40862244","32159401","22509793","22933838","43101196","31444810","22222834","22964255","27096721","35706080","95881456","16787873","20949064","27288454","17485260","39516344","38922040","27240721","30022267","31029231","22226642","20627957","17765932","17438319","16007257","32507469","17973004","40379270","2088160","29560361","28044766","36432877","17121179","36451239","92452932","31987019","32067028","16009244","22374659","21398330","17224587","27965919","17539790","29443289","30327189","35930654","20455898","20183974","14468088","29234867","16054008","27317849","30230054","28476647","16483523","16801717","40367654","26555896","39407061","12697188","21663741","24493680","29338139","35022602","29161939","32194729","26140892","28257637","11566082","12915313","29681186","25683127","37204528","33565038","23472299","36189197","22191396","24041948","44810573","37703653","20255960","37128401","28425167","24714307","40300114","35941687","41258097","33848007","17761729","14857797","40251024","24198449","28729675","23957277","18036934","38867776","36400329","39603703","23966231","24921385","40855229","27792200","25643825","23288313","34300504","22583098","26501879","4263621","29862337","21036327","10507888","39173022","40104823","35199201","38840923","41148502","37770427","32063771","25983881","32850377","11334826","22819632","23169879","27624691","13708670","34394209","32555076","31521530","32027497","38039691","33044777","29078680","36952466","41861413","44306785","36688212","34861001","28990592","24407634","30507989","38796201","39781581","36346858","33416867","30710809","27605520","21481214","26082533","20476279","17875520","37457928","39662727","33464242","26796240","27281762","22934259","40599744","34519337","12131937","37317382","30364456","17550025","29033052","42574701","26141810","42178530","34790158","36820013","26484251","800303459","36284850","31245154","33172149","29093350","34323908","44667540","32429393","20328855","31592030","36944034","35172138","32079766","23142503","27674832","36819367","27385512","36856612","29592064","39153806","35750548","42323175","16804550","43345528","43291206","34711291","21997635","40401038","34437637","94650729","34501011","33780149","43928251","12855588","28851822","25670963","22551541","13962088","33246124","16321471","14523536","4442658","22586452","8701557","6534237","25185306","16160242","17767061","4654273","31283948","22913600","21783745","10966985","14440632","11553711","17318783","6049960","27215006","10956108","22588968","11182006","11556593","7680569","13372706","31956644","27931754","14175658","25455548","21471616","14771069","31194487","18506224","13542043","24705168","33646617","31184718","23477242","31832521","39863226","18086860","29337447","36827200","30549217","14195346","14461063","17270016","17686159","25704979","14151250","800082","33691846","100021","34505519","16161123","25714860","37680692","5539954","28312845","18051649","23513003","16870859","28805045","21911874","16911775","27843569","100020","10350534","24907299","23235211","10632937","22851428","23122524","23757664","11242107","20375547","23287748","34450003","17593874","31376505","25431440","30812991","27851065","23534239","17121092","11831965","24905745","16232054","11215112","18246320","12557795","7657373","26001437","11855606","92194987","20419342","25001798","12398900","7605412","14773191","24583348","10728572","8506447","32946822","16730594","5541523","12902375","22305579","23015851","17848170","14305138","20201617","23059645","24046775","25464669","30633464045","30040889","13440696","17195335","117020461","25790067","18106278","40880280","27136028","35345094","29876374","31062738","39784046","27835865","27910054","100018","29657603","40061259","13730718","6691688","11610733","36434852","37524635","14257243","28755982","34674096","16300405","29438061","20107713","25486984","33212281","30538041","24598871","26350684","24771423","28424002","21740037","38742599","11702046","33963369","22628095"];
    
    const handleOpenCursosModal = () => {
        setShowCursosModal(true);
    };

    const handleCloseCursosModal = () => {
        setShowCursosModal(false);
    };

    const handleGotoCampusFromModal = () => {
        setShowCursosModal(false);
        handleGotoCampus("/campus");
    };

    const getData = async (token) => {
        //const requestURL = `http://localhost:8888/protagonitas_landings/incentivo_tiendas_2.php`;
        //const requestURL = `https://fabianhr.com/protagonistas/incentivo_tiendas_2.php`;
        const requestURL = 'https://v2-dev.1onesolutions.com/API/meta';

        try {
            const params = new URLSearchParams()
            params.append('type', "get_data");
            params.append('uid', uid);

            const config = {
                headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'dni': uid
                //'Authorization': token//storage.getItem('protagonistas_access_token')
                }
            }
            //config.headers.Authorization = idToken.jwtToken;//temp_token;
            const result = await axios.get(requestURL, config, params);
            //console.log("result", result.data.single)
            //setDataDesempeno(result.data.single);

            //setActividadObjetivo(result.data.single.actividad_individual_objetivo);
            //setActividadResultado(result.data.single.actividad_individual_resultado);
            
            
            
            
            
            //setCursosObjetivo(result.data.single.cursos_individual_objetivo);
            //setCursosResultado(result.data.single.cursos_individual_resultado);




            /*
            setCursosResultado(!result.data.single.cursos_individual_objetivo || isNaN(result.data.single.cursos_individual_resultado) || isNaN(result.data.single.cursos_individual_objetivo) ? 0 : Math.round((result.data.single.cursos_individual_resultado / result.data.single.cursos_individual_objetivo) * 100));//result.data.single.cursos_individual_resultado
            setActividadIndividualCalculo(result.data.single.actividad_individual_resultado >= 1 ? '100' : '0');
            setActividadEstacionCalculo(result.data.single.actividad_estacion_resultado >= 1 ? '100' : '0');
            */


            console.log("setMetaData");
            setMetaData(result.data.single.meta);
            setDataStation(result.data.single.meta[0]);
            setModificatedDate(result.data.single.meta[0].modified_date);
            setRed(result.data.single.meta[0].liga?.toLowerCase());
            

            if(uid && !empresarios.includes(uid)/*result.data.single.meta.length === 1*/){
                setActividadObjetivo(result.data.single.meta[0].actividad_individual_objetivo);
                setActividadResultado(result.data.single.meta[0].actividad_individual_resultado/*dataDesempeno.actividad_individual_resultado >= dataDesempeno.actividad_individual_objetivo ? '100' : '0'*/);
                setCursosObjetivo('100%');
                setCursosResultado(!result.data.single.meta[0].cursos_individual_objetivo || isNaN(result.data.single.meta[0].cursos_individual_resultado) || isNaN(result.data.single.meta[0].cursos_individual_objetivo) ? 0 : Math.round((result.data.single.meta[0].cursos_individual_resultado / result.data.single.meta[0].cursos_individual_objetivo) * 100));
            }else{
                setActividadObjetivo(result.data.single.meta[0].actividad_estacion_objetivo/*dataDesempeno.actividad_estacion_objetivo*/);
                setActividadResultado(!result.data.single.meta[0].actividad_estacion_objetivo || isNaN(result.data.single.meta[0].actividad_estacion_resultado) || isNaN(result.data.single.meta[0].actividad_estacion_objetivo) ? 0 : Math.round((result.data.single.meta[0].actividad_estacion_resultado / result.data.single.meta[0].actividad_estacion_objetivo) * 100));
                setCursosObjetivo('90%');//dataDesempeno.cursos_estacion_objetivo
                //console.log("XXXXXX", result?.data?.single?.meta[0].boca)
                
                if(result?.data?.single?.meta[0].boca === '548'){
                    setCursosResultado(90);
                }else{
                    setCursosResultado(!result.data.single.meta[0].nomina || isNaN(result.data.single.meta[0].nomina_completion) || isNaN(result.data.single.meta[0].nomina) ? 0 : (Math.round((result.data.single.meta[0].nomina_completion / result.data.single.meta[0].cursos_estacion_objetivo) * 100)) > 100 ? 100 : Math.round((result.data.single.meta[0].nomina_completion / result.data.single.meta[0].nomina) * 100));
                    //setCursosResultado(!data.nomina || isNaN(data.nomina_completion) || isNaN(data.nomina) ? 0 : (Math.round((data.nomina_completion / data.cursos_estacion_objetivo) * 100)) > 100 ? 100 : Math.round((data.nomina_completion / data.nomina) * 100));
                }
                    
                
            }
            
            return result;

        } catch (error) {

        }
    }
    /*
    const getData = async () => {
        const requestURL = `http://localhost:8888/protagonitas_landings/mas_power_que_nunca.php`;
        //const requestURL = `http://localhost:8888/protagonitas_landings/incentivo_tiendas_2.php`;
        //const requestURL = `https://fabianhr.com/protagonistas/incentivo_tiendas_2.php`;

        try {
            const params = new URLSearchParams()
            //params.append('type', "get_data");
            params.append('uid', uid);

            const config = {
                headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
                }
            }

            const result = await axios.post(requestURL, params, config);
            setMetaData(result.data.metas);
            setDataStation(result.data.metas[0]);

            return result;

        } catch (error) {

        }
    }
    */
    const handleChangeBoca = (e) => {
        const data = metaData.filter(el => el.boca === e.target.value);
        setDataStation(data[0]);
        if(uid && !empresarios.includes(uid)/*metaData?.length === 1*/){
            handleChangeTab('actividad', tabActividad, data[0]);
            handleChangeTab('cursos', tabCursos, data[0]);
        }else{
            handleChangeTab('actividad', 'estacion', data[0]);
            handleChangeTab('cursos', 'estacion', data[0]);
        }
    }

    const handleDownloadPDF = (pdf) => {

        switch (pdf) {
            case "reglamento_co":
                window.open('pdfs/Reglamento_Competencia_Promo_Jeep_Red_CO-1709_2025.pdf', '_blank').focus();
            break;
            case "reglamento_do":
                window.open('pdfs/Reglamento_Competencia_Promo_Jeep_Red_DO-1709_2025.pdf', '_blank').focus();
            break;
            case "macanica_do":
                window.open('pdfs/COMPETENCIA_PROMO_JEEP_Mecanica_DO.pdf', '_blank').focus();
            break;
            case "macanica_co":
                window.open('pdfs/COMPETENCIA_PROMO_JEEP_Mecanica_CO.pdf', '_blank').focus();
            break;
            case "tips":
                //window.open('pdfs/Instructivo_Meta_Promo_Autitos_Coleccionables.pdf', '_blank').focus();
            break;
          default:
            break;
        }
    
    }

    const handleChangeTab = (type, tab, data) => {
        if(type === 'actividad'){
            setTabActividad(tab);
            if(tab === 'individual'){
                setActividadObjetivo(data.actividad_individual_objetivo);
                setActividadResultado(data.actividad_individual_resultado);
            } else {
                setActividadObjetivo(data.actividad_estacion_objetivo);
                setActividadResultado(!data.actividad_estacion_objetivo || isNaN(data.actividad_estacion_resultado) || isNaN(data.actividad_estacion_objetivo) ? 0 : Math.round((data.actividad_estacion_resultado / data.actividad_estacion_objetivo) * 100));

            }
        }
        if(type === 'cursos'){
            setTabCursos(tab);
            if(tab === 'individual'){
                setCursosObjetivo('100%');
                setCursosResultado(!data.cursos_individual_objetivo || isNaN(data.cursos_individual_resultado) || isNaN(data.cursos_individual_objetivo) ? 0 : Math.round((data.cursos_individual_resultado / data.cursos_individual_objetivo) * 100));
            } else {
                console.log("data", dataStation?.boca)
                setCursosObjetivo('90%');
                if(dataStation?.boca === 548){
                    setCursosResultado(100);
                }else{
                    setCursosResultado(!data.nomina || isNaN(data.nomina_completion) || isNaN(data.nomina) ? 0 : (Math.round((data.nomina_completion / data.cursos_estacion_objetivo) * 100)) > 100 ? 100 : Math.round((data.nomina_completion / data.nomina) * 100));
                }
            }
        }
    }

    const handleGotoCampus = (path) => {
        window.open(path, '_blank');
    }

    const handleOpenVideoModal = () => {
        setShowVideoModal(true);
        setIsPlaying(true);
    };

    const handleCloseVideoModal = () => {
        setShowVideoModal(false);
        setIsPlaying(false);
    };

    useEffect(() => {
        
        if(uid){
            getData();
        }
    
      return () => {}
    }, [uid])
    
    useEffect(() => {

        if(userData){
            if(userData.dni){
                
                if(!inventivo_tiendas_2.includes(userData?.dni)){
                    //history.push('/');
                }
            }
        }
      
        return () => {}
      }, [userData])

      useEffect(() => {
        //console.log("actividadObjetivo", actividadObjetivo)
      
        return () => {}
      }, [actividadObjetivo])
      
      useEffect(() => {
        console.log("metaData", metaData)
      
        return () => {}
      }, [metaData])
      
    if(metaData === null){
        return <div style={{ display: 'flex', width: '100%', paddingTop: '25px', justifyContent: 'center', alignItems: 'center' }}><CircularProgress style={{ color: '#E30613' }} /></div>;
    }

    
    
    
    return (
        <Wrapper>
            {(!metaData && !userData && !dataStation) ? 

                <div className='loading'>
                    <CircularProgress />
                </div>

                :
            
                <div className='inner'>
                    <div className='logos'>

                        <div className='logo_jeep_shell'>
                            <img src='images/promo_jeep_shell.svg' />
                        </div>

                        <div className='logo_shell_tag'>
                            <img src='images/promo_shell_tag.svg' />
                        </div>

                        <div className='logo_jeep_shellbox'>
                            <img src='images/promo_jeep_shellbox.svg' />
                        </div>
                        {/* <div className='select'>
                            <div className='logo'>
                                <img src='images/logo_shell_select.svg' />
                            </div>
                        </div>
                        <div className='box'>
                            <div className='logo'>
                                <img src='images/logo_shellbox_incentivo_tiendas.png' />
                            </div>
                        </div>
                        <div className='shop'>
                            <div className='logo'>
                                <img src='images/Shell-SHOP.jpg' />
                            </div>
                        </div> */}
                    </div>
                    <div className='description'>
                        Protagonistas se sube a la aventura con la competencia y el premio más grande de su historia.
                    </div>
                    {/* <div className='title'>
                        META <span className='brand'>Shell BOX</span><br/>EN TIENDAS 
                    </div> */}
                    <div className='data_station'>
                        <div className='station'>
                            <div className='label'>Boca</div> 
                            <div className='value'>{dataStation?.boca}</div>
                        </div>
                        {/* <div className='name'>
                            <div className='label'>
                                Razon Social
                            </div>
                            <div className='value'>{dataStation?.razon}</div>
                        </div> */}
                        {metaData?.length > 1 ?
                        <div className='select_boca'>
                            <label>Seleccionar boca</label>
                            <select id="" onChange={handleChangeBoca}>
                                {metaData.map((boca, index) => {
                                    return(
                                        <option value={boca.boca}>{`${boca.boca} - ${boca.razon_social}`}</option>
                                    )
                                })}
                            </select>
                        </div>
                        : ""}
                    </div>

                    <div className='objectives_container'>
                    <div className='objective_container'>
                    <div className='objective_title'>
                        Meta de Negocio
                    </div>

                    <div className='box_objectives'>

                        <div className='box_objective'>
                            <ul>
                                <li className='title'>
                                    <div className='label'>
                                        SHELL VPOWER (%)
                                    </div>
                                </li>
                                <li>
                                    <div className='label'>
                                        Meta
                                    </div>
                                    <div className='value'>
                                        {dataStation?.autitos_pre_registro ? dataStation.autitos_pre_registro : '---'}
                                    </div>
                                </li>
                                <li>
                                    <div className='label'>
                                        Resultado
                                    </div>
                                    <div className='value'>
                                        {dataStation?.resultado_shellvpower ? dataStation.resultado_shellvpower : '---'}
                                    </div>
                                </li>
                                <li>
                                    <div className='label'>
                                        Cumplimiento
                                    </div>
                                    <div className='value'>
                                        {dataStation?.cumplimiento_shellvpower ? dataStation.cumplimiento_shellvpower : '---'}
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div className='box_objective'>
                            <ul>
                                <li className='title'>
                                    <div className='label'>
                                        SHELL BOX PLAYA
                                    </div>
                                </li>
                                <li>
                                    <div className='label'>
                                        Meta
                                    </div>
                                    <div className='value'>
                                        {dataStation?.stock_autitos ? dataStation.stock_autitos : '---'}
                                    </div>
                                </li>
                                <li>
                                    <div className='label'>
                                        Resultado
                                    </div>
                                    <div className='value'>
                                        {dataStation?.autitos_vendidos ? dataStation.autitos_vendidos : '---'}
                                    </div>
                                </li>
                                <li>
                                    <div className='label'>
                                        % de Cumplimiento
                                    </div>
                                    <div className='value'>
                                        {dataStation?.porcentaje_stock ? dataStation.porcentaje_stock : '---'}
                                    </div>
                                </li>
                            </ul>
                        </div>
                        
                        <div className='box_objective'>
                            <ul>
                                <li className='title'>
                                    <div className='label'>
                                        SHELL BOX TIENDA
                                    </div>
                                </li>
                                <li>
                                    <div className='label'>
                                        Meta
                                    </div>
                                    <div className='value'>
                                        {/* {dataStation?.meta_tiendas ? dataStation.meta_tiendas : '---'} */}
                                        {dataStation?.meta_tiendas ? dataStation.liga === "DO" ? parseInt(Math.round(dataStation.meta_tiendas)) : dataStation.meta_tiendas : '---'}
                                    </div>
                                </li>
                                <li>
                                    <div className='label'>
                                        Resultado
                                    </div>
                                    <div className='value'>
                                        {dataStation?.resultado_tiendas ? dataStation.resultado_tiendas : '---'}
                                    </div>
                                </li>
                                <li>
                                    <div className='label'>
                                        Cumplimiento
                                    </div>
                                    <div className='value'>
                                        {dataStation?.cumplimiento_tiendas ? dataStation.cumplimiento_tiendas : '---'}
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    </div>
                    <div className='objective_container'>
                    <div className='objective_title'>
                        Meta de Desempeño
                    </div>
                    <div className='box_objectives_extras'>
                        <div className='box_objective_extras'>
                            {uid && !empresarios.includes(uid) ? //metaData?.length === 1 ?
                                <div className='tabs'>
                                    <div className={`tab${tabActividad === 'individual' ? ' active' : ''}`} onClick={() => handleChangeTab('actividad', 'individual', dataStation)}>Individual</div>
                                    <div className={`tab${tabActividad === 'estacion' ? ' active' : ''}`} onClick={() => handleChangeTab('actividad', 'estacion', dataStation)}>Estación</div>
                                </div>
                            : 
                                <div className='tabs'>
                                    <div className={`tab alone`} onClick={() => null}>Estación</div>
                                </div>
                            }
                            <div className='title'>
                                <div className='label'>
                                    ACTIVIDAD (Ingresos)
                                </div>
                            </div>
                            <ul>

                                <li>
                                    <div className='label'>
                                        Objetivo
                                    </div>
                                    <div className='value'>
                                        {actividadObjetivo}
                                        {/* {'---'} */}
                                        {/* {actividadObjetivo ? actividadObjetivo : '---'} */}
                                    </div>
                                </li>
                                <li>
                                    <div className='label'>
                                        Resultado
                                    </div>
                                    <div className='value'>
                                        {actividadResultado}
                                        {/* {'---'} */}
                                        {/* {actividadResultado ? (actividadResultado > 100 ? 100 : actividadResultado) + '%' : '---'} */}
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className='box_objective_extras'>
                            {uid && !empresarios.includes(uid) ? //metaData?.length === 1 ?
                                <div className='tabs'>
                                    <div className={`tab${tabCursos === 'individual' ? ' active' : ''}`} onClick={() => handleChangeTab('cursos', 'individual', dataStation)}>Individual</div>
                                    <div className={`tab${tabCursos === 'estacion' ? ' active' : ''}`} onClick={() => handleChangeTab('cursos', 'estacion', dataStation)}>Estación</div>
                                </div>
                            : 
                                <div className='tabs'>
                                    <div className={`tab alone`} onClick={() => null}>Estación</div>
                                </div>
                            }
                            <div className='title'>
                                <div className='label'>
                                    CURSOS (Cumplimiento)
                                </div>
                            </div>
                            <ul>
                                <li>
                                    <div className='label'>
                                        Objetivo
                                    </div>
                                    <div className='value'>
                                        {cursosObjetivo}
                                        {/* {'---'} */}
                                        {/* {cursosObjetivo ? cursosObjetivo : '---'} */}
                                    </div>
                                </li>
                                <li>
                                    <div className='label'>
                                        Resultado
                                    </div>
                                    <div className='value'>
                                        {/* {cursosResultado} */}
                                        {/* {'---'} */}
                                        {cursosResultado ? (cursosResultado > 100 ? 100 : cursosResultado) + '%' : '0%'}
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className='publish_date'>
                        <div className='icon shake-bell'><HiMiniBellAlert /></div>
                        <p>Si tenés alguna consulta, escribinos a contacto@somosprotagonistas.com.ar</p>
                    </div>
                    </div>
                    </div>
                    
                    
                     <ButtonYellow
                        className="bt_cursos_pendientes"
                        onClick={handleOpenCursosModal}
                        //onClick={() => handleGoto()}
                        //onClick={() => handleGotoCampus("/campus")}
                        disabled={false}
                        css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                        >
                        <p>Cursos Pendientes</p>
                    </ButtonYellow>
                   

                    {red === 'co' &&
                    <div className='actions'>

                        <ButtonYellow
                            className="bt_download_tips_shell_box"
                            //onClick={() => handleGoto()}
                            onClick={() => handleOpenVideoModal()/*handleGotoCampus("/campus/course/10:68767c73b780bbe104950ad5")*/}
                            disabled={false}
                            css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                            >
                            <p>TIPS SHELL BOX</p>
                        </ButtonYellow>

                        <ButtonYellow
                            className="bt_download_tips_shell_vpower"
                            //onClick={() => handleGoto()}
                            onClick={() => handleGotoCampus("/campus/course/10:68767c73b780bbe104950ad5")}//"/campus/course/22:68a5d21de46be4dd96cb877a"
                            disabled={false}
                            css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                            >
                            <p>TIPS SHELL VPOWER</p>
                        </ButtonYellow>

                        <ButtonYellow
                            className="bt_download_reglamento"
                            onClick={() => handleDownloadPDF("reglamento_co")}
                            disabled={false}
                            css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                            >
                            <p>REGLAMENTO</p>
                        </ButtonYellow>

                        <ButtonYellow
                            className="bt_download_mecanica"
                            onClick={() => handleDownloadPDF("macanica_co")}
                            disabled={false}
                            css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                            >
                            <p>MECÁNICA</p>
                        </ButtonYellow>

                    </div>}

                    {red === 'do' &&
                    <div className='actions'>

                        <ButtonYellow
                            className="bt_download_tips_shell_box"
                            //onClick={() => handleGoto()}
                            onClick={() => handleOpenVideoModal()/*handleGotoCampus("/campus/course/10:68767c73b780bbe104950ad5")*/}
                            disabled={false}
                            css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                            >
                            <p>TIPS SHELL BOX</p>
                        </ButtonYellow>

                        <ButtonYellow
                            className="bt_download_tips_shell_vpower"
                            //onClick={() => handleGoto()}
                            onClick={() => handleGotoCampus("/campus/course/10:68767c73b780bbe104950ad5")}//"/campus/course/22:68a5d21de46be4dd96cb877a"
                            disabled={false}
                            css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                            >
                            <p>TIPS SHELL VPOWER</p>
                        </ButtonYellow>
                         
                        <ButtonYellow
                            className="bt_download_reglamento"
                            onClick={() => handleDownloadPDF("reglamento_do")}
                            disabled={false}
                            css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                            >
                            <p>REGLAMENTO</p>
                        </ButtonYellow>

                        <ButtonYellow
                            className="bt_download_mecanica"
                            onClick={() => handleDownloadPDF("macanica_do")}
                            disabled={false}
                            css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '250px'}}
                            >
                            <p>MECÁNICA</p>
                        </ButtonYellow>

                    </div>}
                    
                   
                    {/* <div className='aclaracion_48'>En las próximas 48 hs. ya vas a tener disponibles los avances en la meta de negocio de tu estación y en tu meta desempeño.</div> */}

                    <div className='copy'>
                        {/* <p className='l1'>Las estaciones compiten según ligas: Liga A a partir de 150 txs / Liga B  desde 50 a 149 txs / Liga C desde 30 a 49 txs</p> */}
                        {modificatedDate && (
                            <p className='l2'>
                                Vigencia de la información Meta Negocio desde el 1 al {/*parseInt(dayjs.utc(modificatedDate).subtract(1, 'day').format('DD'))*/} 15 de septiembre.
                            </p>
                        )}
                        <p className='l2'>Los resultados se actualizarán cada 24 a 48hs. hábiles.</p> 
                        {/* <p className='l3'>Fecha actualización {modificatedDate ? dayjs(modificatedDate).format('DD/MM/YYYY') : '---'}</p> */}
                    </div>

                    <div className='renegade'>
                        <div className='image'>
                            <img src='images/renegade.png' />
                        </div>
                    </div>

                    {/* <div className='box_objective'>
                        <ul>
                            <li>
                                <div className='label'>
                                    Promedio Mensual TXS
                                </div>
                                <div className='value'>
                                    {dataStation?.promedio ? dataStation.promedio : '---'}
                                </div>
                            </li>
                            <li>
                                <div className='label'>
                                    Resultado
                                </div>
                                <div className='value'>
                                    {dataStation?.resultado ? dataStation.resultado : '---'}
                                </div>
                            </li>
                            <li>
                                <div className='label'>
                                    % de Cumplimiento
                                </div>
                                <div className='value'>
                                    {dataStation?.incremento ? dataStation.incremento : '---'}
                                </div>
                            </li>
                        </ul>
                    </div> */}

                    
                </div>
            }

            {showCursosModal && (
                <div className='cursos_modal_overlay' onClick={handleCloseCursosModal}>
                    <div className='cursos_modal_content' onClick={(e) => e.stopPropagation()}>
                        <div className='cursos_modal_header'>
                            <button className='close_button' onClick={handleCloseCursosModal}>
                                ✕
                            </button>
                        </div>
                        <div className='cursos_modal_body'>
                            <h3>Cursos Pendientes</h3>
                            <p>
                                Para revisar cuáles son tus cursos pendientes, ingresá a <strong>Campus</strong>, en la categoría <strong>"Cursos pendientes"</strong>.<br/>
                                En el título de cada curso podrás verificar si es <strong>obligatorio según tu puesto.</strong><br/><br/>
                                Si sos <strong>Empresario y/o Encargado</strong>, te pedimos que revises esta información desde tu acceso al <strong>Panel</strong>, en la sección <strong>Indicadores</strong>.
                            </p>
                            <div className='cursos_modal_actions'>
                                <ButtonYellow
                                    onClick={handleGotoCampusFromModal}
                                    disabled={false}
                                    css_styles={{background:{normal: '#FFD200', hover: '#000000'}, width: '200px'}}
                                    >
                                    <p>IR A CAMPUS</p>
                                </ButtonYellow>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showVideoModal && (
                <div className='video_modal_overlay' onClick={handleCloseVideoModal}>
                    <div className='video_modal_content' onClick={(e) => e.stopPropagation()}>
                        <div className='video_modal_header'>
                            <button className='close_button' onClick={handleCloseVideoModal}>
                                ✕
                            </button>
                        </div>
                        <div className='video_modal_player'>
                            <ReactPlayer
                                className="react-player-modal"
                                playing={isPlaying}
                                url="https://vimeo.com/1117289649"
                                width="100%"
                                height="100%"
                                controls={true}
                                onPlay={() => setIsPlaying(true)}
                                onPause={() => setIsPlaying(false)}
                                config={{ 
                                    vimeo: {
                                        playerOptions: {
                                            controls: true,
                                            interactive_markers: false,
                                            interactive_params: false,
                                            vimeo_logo: false,
                                            play_button_position: "center",
                                            progress_bar: true,
                                            title: false,
                                            responsive: true
                                        }
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}

        </Wrapper>
    );
};

export default MetaJeep;